<template>
    <div id="konfigurator-hmotnostkondice">

        <h1>{{ 'Enter the current weight' | translate }}</h1>
        <span :class="{'is-refreshed' : refreshWeight}"></span>
        <div v-show="(!isValidHmotnost() || !isKondiceValid()) && this.tryescape" class="info-messages-box">
            <div v-if="!isValidHmotnost() && this.tryescape" class="error-msg">
                {{ "You have to choose your pet's weight" | translate }}
            </div>
            <div v-if="!isKondiceValid() && this.tryescape" class="error-msg">
                {{ "You have to choose your pet's fitness" | translate }}
            </div>
        </div>

        <div class="form-content"
             v-bind:class="{ 'has-error':!isValidHmotnost() && this.tryescape,'has-success':isValidHmotnost() && this.tryescape }">

            <div class="input-blok input-vaha">
                <!--<vue-numeric-->
                <!--min="0"-->
                <!--max="100"-->
                <!--separator="."-->
                <!--v-bind:minus="false"-->
                <!--v-bind:precision="1"-->
                <!--placeholder="Doplňte, jakou má  hmotnost"-->
                <!--v-model="mazlicek.hmotnostkondice.hmotnost"-->
                <!--class="form-control"-->
                <!--&gt;</vue-numeric>-->
                <input class="form-control form-control-vaha" v-model="petWeight" type="number"
                       :placeholder="'Enter the weight of your pet' | translate"
                       min="0" max="100"/>
                <div class="form-type-select select-jednotky">
                    <div class="select-content">
                        <select class="form-select" v-model="mazlicek.hmotnostkondice.hmotnostJednostka">
                            <option value="kg">kg</option>
                            <option value="lb">lb</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="alert alert-info" v-show="!mazlicek.jeStene && !this.checkPrumHmotnost">
                <p>{{ 'Are you sure about the weight of your pet?' | translate }}</p>
            </div>
            <div v-if="!mazlicek.jeStene" class="hmotnost-kondice-title">
                {{ 'Determine honestly how fit it is now' | translate }}
            </div>

            <div v-if="!mazlicek.jeStene" class="form-radios"
                 v-bind:class="{ 'has-error':!isKondiceValid() && this.tryescape }">
                <div class="form-type-radio" :key="key" v-for="(item, key) in kondiceItems">
                    <input type="radio" v-model="mazlicek.hmotnostkondice.kondice" v-bind:value="item.id" :id="item.id"
                           :placeholder="'Enter current weight' | translate">
                    <label :for="item.id">
                        <div class="item-title">{{ item.title }}</div>
                        <div v-if="item.description.length > 0" class="item-desc" v-html="item.description"></div>
                    </label>
                </div>
            </div>
            <div v-else class="infobox">
                {{
                    "For an adult dog, you select what current condition it is in. For puppies, this is not relevant for the calculation of Haffit. Choose the 'Continue' button."
                    | translate
                }}
            </div>

        </div>

        <info v-if="!mazlicek.jeStene" :krok="6"></info>

        <navigace
                :showPrev="true"
                :onClickPrev="prev"
                :showNext="true"
                :onClickNext="next"
                :onClickSaveAndQuit="saveAndQuit"
        ></navigace>


    </div>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {required, between} from 'vuelidate/lib/validators'
    import {apiSilex} from '../api'
    import navigace from './Navigace'
    import info from './Info'
    import filters from '../filters'

    export default {
        components: {navigace, info},
        mixins: [validationMixin],
        data: function () {
            return {
                mazlicek: this.$store.state.mazlicek,
                mazlicekWeight: this.$store.state.mazlicek.hmotnostkondice.hmotnost,
                kondiceItems: [],
                pHmotnost: 0,
                pHmotnostProc: 30,
                pHmotnostMin: 0,
                pHmotnostMax: 0,
                tryescape: false,
                petWeight: ""
            }
        },
        computed: {
            vahaPlaceholder() {
                return 'Doplňte, jakou má ' + this.mazlicek.jmeno.value + ' hmotnost'
            },
            checkPrumHmotnost: function () {
                var x = (this.pHmotnost / 100) * this.pHmotnostProc
                this.pHmotnostMin = this.pHmotnost - x
                this.pHmotnostMax = this.pHmotnost + x

                const hmotnostKg = this.mazlicek.hmotnostkondice.hmotnostJednostka == 'lb' ? this.petWeight * 0.45359237 : this.petWeight
                if (hmotnostKg > 0) {
                    return (hmotnostKg >= this.pHmotnostMin && hmotnostKg <= this.pHmotnostMax)
                } else {
                    return true
                }
            },
            refreshWeight() {
                // this.petWeight = filters.round(this.mazlicek.hmotnostkondice.hmotnostJednostka == 'lb' ? this.mazlicek.hmotnostkondice.hmotnost / 0.45359237 : this.mazlicek.hmotnostkondice.hmotnost)
                return this.petWeight
            }
        },
        methods: {
            prev: function () {
                this.$router.push({name: 'pohlavi'})
            },
            saveAndQuit: function () {
              if (this.isStepValid()) {
                if (this.mazlicek.hmotnostkondice.hmotnostJednostka == 'lb') {
                  this.mazlicek.hmotnostkondice.hmotnost = this.petWeight * 0.45359237
                } else {
                  this.mazlicek.hmotnostkondice.hmotnost = this.petWeight
                }
                this.mazlicek.hmotnostkondice.valid = true
                this.$store.dispatch('updatePet', this.mazlicek)
                  .then(response => {
                    this.mazlicek.hmotnostkondice.valid = true
                    this.mazlicek.pohyb.valid = true
                    window.location.href = 'prihlaseni'
                  }, error => {
                    console.error(error)
                  })
              } else {
                this.tryescape = true
                this.animateAfterError()
              }
            },
            next: function () {
                // this.$store.commit('setMazlicek', this.mazlicek)

                if (this.isStepValid()) {
                    if (this.mazlicek.hmotnostkondice.hmotnostJednostka == 'lb') {
                        this.mazlicek.hmotnostkondice.hmotnost = this.petWeight * 0.45359237
                    } else {
                        this.mazlicek.hmotnostkondice.hmotnost = this.petWeight
                    }
                    this.mazlicek.hmotnostkondice.valid = true
                    this.$store.dispatch('updatePet', this.mazlicek)
                        .then(response => {

                            this.mazlicek.hmotnostkondice.valid = true
                            this.mazlicek.pohyb.valid = true
                            this.$router.push({name: 'pohyb'})
//                            this.$router.push({name: 'alergie'})
                        }, error => {
                            console.error(error)
                        })
                } else {
                    this.tryescape = true
                    this.animateAfterError()
                }
            },
            isValidHmotnost: function () {
                return this.petWeight !== null && this.petWeight > 0
            },
            isKondiceValid: function () {
                return this.mazlicek.hmotnostkondice.kondice !== null || this.mazlicek.jeStene
            },
            isStepValid: function () {
                return this.isValidHmotnost() && this.isKondiceValid()
            },
            animateAfterError(){
                jQuery('html, body').animate({
                        scrollTop: jQuery('.app-content-left').offset().top - jQuery('#primary').height()
                    },
                    '500'
                )
            },
          getAvargeWeight() {
            apiSilex.get('/hmotnost').then(
                response => {
                  let self = this;
                  response.data.forEach(function (element) {
                    element.description = self.tokenReplace(element.description, '[name]', self.mazlicek.jmeno.value);
                  })
                  this.kondiceItems = response.data
                }
            )


                if (this.mazlicek.rasa.typ === 'app_rasa') {
                    var url = '/rasa/' + this.mazlicek.rasa.id + '/pvaha'
                    if (this.mazlicek.pohlavi.value === 'pes') {
                        apiSilex.get(url).then(
                            response => (this.pHmotnost = parseFloat(response.data.pes))
                        )
                    } else {
                        apiSilex.get(url).then(
                            response => (this.pHmotnost = parseFloat(response.data.fena))
                        )
                    }
                } else {
                    var url = '/velikost/' + this.mazlicek.rasa.velikost + '/pvaha'
                    if (this.mazlicek.pohlavi.value === 'pes') {
                        apiSilex.get(url).then(
                            response => (this.pHmotnost = parseFloat(response.data.pes))
                        )
                    } else {
                        apiSilex.get(url).then(
                            response => (this.pHmotnost = parseFloat(response.data.fena))
                        )
                    }
                }
            },
            getPetWeight: function () {
                return filters.round(this.mazlicek.hmotnostkondice.hmotnostJednostka == 'lb' ? this.mazlicek.hmotnostkondice.hmotnost / 0.45359237 : this.mazlicek.hmotnostkondice.hmotnost, 1)
            },

          tokenReplace(haystack, needle, replacement) {
            return haystack.split(needle).join(replacement)
          },
        },
//        beforeUpdate: function () {
//            if (this.mazlicek.hmotnostkondice.hmotnost)
//                this.petWeight = filters.round(this.mazlicek.hmotnostkondice.hmotnostJednostka == 'lb' ? this.mazlicek.hmotnostkondice.hmotnost / 0.45359237 : this.mazlicek.hmotnostkondice.hmotnost)
//        },
        mounted: function () {
            this.mazlicek.step.current = 6
            this.$cookies.set('lastVisitedStep', 6)
            jQuery('html, body').animate({scrollTop: 0}, '500')

            if (this.mazlicek.hmotnostkondice.hmotnost)
                this.petWeight = this.getPetWeight()

            this.getAvargeWeight();
        },
        watch: {
            'mazlicek.petLoaded.value': {
                deep: true,
                handler: function (val) {
                    if (val)
                        this.petWeight = this.getPetWeight()

                    this.getAvargeWeight();
                }
            }
        }
//        validations: {
//            mazlicek: {
//                hmotnostkondice: {
//                    hmotnost: {
//                        required
//                    }
//                }
//            }
//        },
    }
</script>



// WEBPACK FOOTER //
// 06HmotnostKondice.vue?728526ea